export default function () {
  if (this.$route.name === 'EditMessageTemplate') {
    this.loadTemplate()
  }
}
